import { Component } from '@angular/core';
import { UnitConversionService } from '../../services/unit-conversion.service';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
})
export class MobileHeaderComponent {
  isOpen = false;

  constructor(
    public unitConversionService: UnitConversionService,
    private analyticsService: AnalyticsService
  ) {}

  toggleHeader() {
    this.isOpen = !this.isOpen;
  }

  setHeaderState(state: boolean) {
    this.isOpen = state;
  }

  async onUnitChanged(event: any) {
    const { value } = event;
    await this.unitConversionService.setUnit(value);
    this.analyticsService.trackEvent('DISTANCE_UNIT_CHANGED', value);
  }
}
